import React from 'react';
import { translator } from '../i18n';
import { AdmListStatusProps } from './interface';

import { Container, Status } from './styles/StyledAdmListStatus';

const AdmListStatus: React.FC<AdmListStatusProps> = ({ status }) => {
  return (
    <Container>
      {status === 'ACTIVE' && (
        <Status status={status}>{translator('Ativo')}</Status>
      )}
      {status === '2FAWAIT' && (
        <Status status={status}>{translator('Pendente')}</Status>
      )}
      {(status === 'SUSPENDED' || status === 'REMOVED') && (
        <Status status={status}>{translator('Inativo')}</Status>
      )}
    </Container>
  );
};

export default AdmListStatus;
